import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuoteModel } from 'src/app/models/quote.model';
import { SiteContentService } from 'src/app/services/site-content.service';
import { QuickQuoteCIHelper } from '../quick-quote-ci.helper';

@Component({
  selector: 'app-custom-quote',
  templateUrl: './custom-quote.component.html',
  styleUrls: ['./custom-quote.component.scss'],
})
export class CustomQuoteComponent implements OnInit {

  @Input() quote: QuoteModel;
  @Input() term: number;
  @Output() select = new EventEmitter<QuoteModel>();

  loading = false;
  customQuote: QuoteModel;
  sumAssured: number;
  error: string;
  formError: string;
  submitted = false;
  mode: 'display' | 'form' = 'form';

  constructor(
    private siteContentService: SiteContentService,
    private quickQuoteCIService: QuickQuoteCIHelper
  ) { }

  ngOnInit() {
  }

  reset() {
    this.submitted = false;
    this.formError = '';
    this.mode = 'form';
  }

  async getCustomQuote() {
    if (this.sumAssured == this.customQuote?.result.sumAssured) {
      this.mode = 'display';
      return;
    };

    this.submitted = true;
    if (!this.sumAssured || this.sumAssured == 0) {
      this.formError = "Please enter a valid amount."
      return;
    }

    this.loading = true;
    this.customQuote = null;
    try {
      const rspCustom = await this.quickQuoteCIService.getCIQuote(this.quote, this.sumAssured, this.term);
      if (rspCustom.error) {
        this.formError = rspCustom.error;
        return;
      }
      this.customQuote = rspCustom.quote;
      this.mode = 'display';
    } catch (err) {
      let content = await this.siteContentService.getSiteContent("QuickQuote.ApiAccessError");
      this.formError = content.body;
    } finally {
      this.loading = false;
    }
  }

}
